module.exports = __webpack_public_path__ + "img/1440.083eed32.jpg";